// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * 
 */
enum Type {
    WAITING = 'WAITING', 
    SIGNED = 'SIGNED', 
    APPROVED = 'APPROVED', 
    REJECTED = 'REJECTED', 
    ALL = 'ALL'
};
export default Type;

